<app-public-layout>
    <app-landing-content></app-landing-content>
</app-public-layout>
